var isValid = function isValid(date) {
  if (Object.prototype.toString.call(date) === '[object Date]') {
    return !isNaN(date.getTime());
  }
  return false;
};
export default {
  isValid: isValid
};